






















































































import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getLookupTypeByGroup, DDLItem } from '@/api/common/select'
import { enFirstType } from '@/configs/enums'
import { copyArray, tryToStr } from '@/configs/functions'
import { LookupData, getData, putData, postData } from '@/api/systemManage/lookup'
import { validateIntKey, showVaildMsg } from '@/configs/validate'
import PageForm from '@/components/pageLayout/form.vue'

import { namespace } from 'vuex-class'
const DataSourceModule = namespace('dataSource')

const getFormRules = (id: number, form: { [key: string]: string | any }) => {
  return {
    LookupType: [{ required: true, message: '请选择数据类型', trigger: 'change' }],
    ItemCode: [{ required: true, message: '请输入编码', trigger: 'change' }],
    ItemValue: [{ required: true, message: '请输入数据内容', trigger: 'blur' }],
    SubSequence: [{ required: true, validator: validateIntKey('请输入排序'), trigger: 'blur' }]
  }
}

@Component({
  components: { PageForm }
})
export default class LookupForm extends Vue {
  public collapseNames = ['base']
  public loading = false

  public flagText2: string = '标识2'
  get flagText1(): string {
    var text1 = '标识1'
    var text2 = '标识2'
    switch (this.form.LookupType) {
      case 'UserType':
        text1 = '是否开放'
        break
      case 'DateRangeFilter':
        text1 = '默认查询项'
        break
      case 'HeritageLevel':
        text1 = '其它单位'
        break
      case 'DocumentCategory':
        text1 = '用户手册'
        text2 = '视频插件'
        break
      default:
        text1 = '标识1'
        break
    }
    this.flagText2 = text2
    return text1
  }
  public emptyForm: LookupData = {
    Id: 0,
    LookupType: '',
    ItemCode: '',
    ItemValue: '',
    SubSequence: 1,
    ResveredFlag1: false,
    ResveredFlag2: false,
    ResveredDesc: '',
    Comments: '',

    ParentId: 0,
    ParentType: '',
    ParentName: '',
    GroupName: '',
    LookupTypeName: ''
  }
  public form = Object.assign({}, this.emptyForm)
  public firstType = enFirstType.Select
  public groupList: DDLItem[] = []
  public typeList: DDLItem[] = []

  public rules = getFormRules(0, this.form)
  public $refs!: {
    formCtrl: PageForm
  }
  public created() {
    this.fetchSource()
  }
  public mounted() {
    this.fetchData()
  }
  public beforeDestroy() {
  }
  @DataSourceModule.Getter('dataSource')
  public dataSource!: any
  public fetchSource() {
    const data = Object.assign({}, this.dataSource)
    if (data) {
      this.groupList = data.groupList
    }
  }
  public groupChange(reset: number) {
    var f = this.form
    this.typeList = []
    if (reset === 1) {
      f.LookupType = ''
    }
    if (f.GroupName != '') {
      getLookupTypeByGroup(f.GroupName, this.firstType).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          this.typeList = data
        }
      })
    }
  }
  public fetchData() {
    const id = +this.$router.currentRoute.params.id || 0
    this.fetchLookup(id)
  }
  public fetchLookup(id: number) {
    this.loading = true
    getData(id).then((response: { data: any }) => {
      if (response.data) {
        this.form = response.data

        this.rules = getFormRules(this.form.Id, this.form)
        if (this.form.Id == 0) {
          this.$refs.formCtrl.clearValidate()
          const query = this.$route.query
          const groupName = tryToStr(query['GroupName'])
          const lookupType = tryToStr(query['LookupType'])
          if (groupName != '' || lookupType != '') {
            this.form.GroupName = groupName
            this.form.LookupType = lookupType
            this.groupChange(0)
          }
        } else {
          this.groupChange(0)
        }
        this.loading = false
      }
    })
  }
  public onSubmit() {
    const promist =
      this.form.Id > 0
        ? putData(this.form.Id, this.form)
        : postData(this.form)
    promist.then((response: { data: any }) => {
      const data = response.data
      if (data && !data.IsError) {
        const msg = this.form.Id > 0 ? '保存' : '创建'
        this.$message({
          message: `${msg}成功`,
          type: 'success'
        })
        this.$router.push({ path: `/Lookup` })
      } else {
        this.$message({
          dangerouslyUseHTMLString: true, message: `${data.Message}`, type: 'warning'
        })
        console.log(response)
      }
    })
  }
  public onCancel() {
    const q = this.$route.query
    this.$router.push({ path: '/Lookup', query: q })
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    this.fetchData()
  }
}
